import { publicFormUrl, publicLandingUrl } from '../config/app'

/**
 * Copia texto al portapapeles de forma fiable.
 *
 * `navigator.clipboard` no existe en contextos no seguros ni en algunos
 * navegadores móviles, y ahí la copia fallaba en silencio. Se intenta primero
 * la API moderna y, si no está disponible o es rechazada, se recurre a un
 * campo temporal con `document.execCommand('copy')`.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Se continúa con el método alternativo.
  }

  try {
    const field = document.createElement('textarea')
    field.value = text
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.top = '-1000px'
    field.style.opacity = '0'
    document.body.appendChild(field)
    field.select()
    field.setSelectionRange(0, text.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(field)
    return ok
  } catch {
    return false
  }
}

/**
 * URL pública absoluta de una landing, lista para compartir.
 * Siempre usa el dominio definitivo, nunca el dominio temporal de la vista
 * previa.
 */
export function landingUrl(slug: string): string {
  return publicLandingUrl(slug)
}

/** URL pública absoluta de un formulario. */
export function formUrl(slug: string): string {
  return publicFormUrl(slug)
}
